import { decorate, observable, action } from "mobx";
import { getRecentNumbers } from "service/messageService";

class ObservableTestSMSStore {
  recentNumbers = [];
  isLoadingRecent = false;

  totalCharacterCount = 0;
  totalMessagesCount = 0;

  async fetchRecentNumbers() {
    this.isLoadingRecent = true;
    this.error = null;
    try {
      const numbers = await getRecentNumbers();

      this.recentNumbers = numbers.data;
    } catch (error) {
      this.error = error.message;
      console.error("Error fetching recent numbers:", error);
    } finally {
      this.isLoadingRecent = false;
    }
  }

  getPersonalizationForNumber(phoneNumber) {
    const numberData = this.recentNumbers.find(num => num.phoneNumber === phoneNumber);
    return numberData?.personalizationData || {};
  }

  getAllPersonalizationData() {
    return this.recentNumbers.reduce((acc, numberData) => {
      if (numberData.personalizationData) {
        acc[numberData.phoneNumber] = numberData.personalizationData;
      }
      return acc;
    }, {});
  }

  clearError() {
    this.error = null;
  }

  setTotalCharacterCount(count) {
    this.totalCharacterCount = count;
  }

  setTotalMessagesCount(count) {
    this.totalMessagesCount = count;
  }

  updateMessageCounts(characterCount, messageCount) {
    this.totalCharacterCount = characterCount;
    this.totalMessagesCount = messageCount;
  }

  resetMessageCounts() {
    this.totalCharacterCount = 0;
    this.totalMessagesCount = 0;
  }
}

decorate(ObservableTestSMSStore, {
  recentNumbers: observable,
  isLoadingRecent: observable,
  error: observable,
  totalCharacterCount: observable,
  totalMessagesCount: observable,
  fetchRecentNumbers: action,
  clearError: action,
  setTotalCharacterCount: action,
  setTotalMessagesCount: action,
  updateMessageCounts: action,
  resetMessageCounts: action
});

export default new ObservableTestSMSStore();
